/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
  scroll: 1,
});
jQuery("#nav1").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 16,
  vis: 2,
  scroll: 1,
});
new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },
  loop: true,
  // slidesPerView: "auto",
  // centeredSlides: true,
  pagination: { el: ".sp-pagination", clickable: true },
});

var thumbsp = new Swiper("#thumbs-p", {
  direction: "vertical",
  spaceBetween: 6,
  slidesPerView: 4,
  watchSlidesVisibility: true, //防止不可点击
});

let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  speed:0,
   touchEventsTarget: 'container',
  touchEvents:false,
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});

let spImgList = [
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-p1.png",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-p2.png",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-p4.png",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-p3.png",
];
let spImgList2 = [
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-c1.jpg",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-c2.jpg",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-c3.jpg",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-b1.jpg",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-b2.jpg",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-b3.jpg",
  "https://cdn.shopify.com/s/files/1/0877/7891/8712/files/202407132-b4.jpg",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(swiperImage);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            254 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let number = $('#sp-number div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == number)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);
}
$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
let swiperImage = [
  [
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img3.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img5.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img6.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img4.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img8.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img7.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img9.png',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-2.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-1.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-3.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-5.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-6.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-4.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-8.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-7.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img1-9.png',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-2.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-1.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-3.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-5.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-6.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-4.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-8.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-7.png',
    'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/20240802-img2-9.png',
  ],
]
$('#sp-number div').click(function(){
  let index = $(this).index();
  console.log(11111)
   $('.sp-brand-img').removeClass('sp-brand-img-0')
   $('.sp-brand-img').removeClass('sp-brand-img-1')
   $('.sp-brand-img').removeClass('sp-brand-img-2')
   $('.sp-brand-img').addClass('sp-brand-img-'+ index)
  
  let images = swiperImage[index];

  // 更新主 Swiper 图片
  $('#swiper-p1 .swiper-wrapper').empty();
  images.forEach(src => {
    $('#swiper-p1 .swiper-wrapper').append(`
      <div class="swiper-slide">
        <img class="sp-img lazy-load" src="${src}" alt=""/>
      </div>
    `);
  });

  // 更新缩略图 Swiper 图片
  $('#thumbs-p .swiper-wrapper .swiper-slide').each(function(i) {
    if (i < images.length) {
      $(this).find('img').attr('src', images[i]);
    }
  });

  // 重新初始化或更新 Swiper 实例
  if (swiper) {
    swiper.update(); // 更新 Swiper 实例
  } else {
    swiper = new Swiper('.swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
});

$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice()
});

$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项

    let colorOptions = $("#sp-color .option.active").index();

    swiper.slideTo(colorOptions);
    changePrice()
  });
    let imgArr= [
        'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/pipeline34.png?v=1718450490',
        'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/pipeline37.png?v=1718450490',
        'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/pipeline36.png?v=1718450490',
      ]
      $('.sp-number-wraper li').click(function () {
        $(this).addClass('active').siblings().removeClass('active')
        var index = $(this).index();
        $('.sp-pro-img>img').attr('src', imgArr[index])
        changePrice()
      })

  // style选项
  // // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });
 
  $(".product-part .cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });

    // var img = $(".product-part .p-img");
    var img = $(".product-part .sp-swiper .swiper-slide-active img");

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
});
